var _path, _polygon;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAxa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "230.642px",
    height: "204.563px",
    viewBox: "0 0 230.642 204.563",
    enableBackground: "new 0 0 230.642 204.563",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M161.811,130.061c-0.721-2.448-1.08-4.752-1.297-7.416h-15.047c-0.506,2.017-1.297,3.528-2.232,4.968 c-0.721,0.937-1.441,1.801-2.088,2.809l-25.561,33.408l-3.096-9.792l17.856-23.688c1.943-2.52,3.961-5.184,7.129-7.704h-16.129 c-1.08,2.664-3.527,5.4-5.328,7.849l-7.92,10.512l-3.384-10.44c-0.792-2.592-1.296-4.968-1.8-7.92H84.481 c1.584,3.024,2.376,5.544,3.024,7.488l8.712,26.568l-5.472,7.199l-10.656-33.407c-0.72-2.593-1.224-4.465-1.224-7.849H63.673 c-0.432,2.017-1.224,3.672-2.088,5.112c-0.504,0.936-1.08,1.8-1.728,2.664l-46.8,61.848c-2.16,2.88-3.672,4.464-9.504,9.504h15.336 l24.696-32.76h31.608l3.6,10.944l-9.216,12.096c-2.016,2.664-4.32,5.616-7.992,8.856c-0.288,0.287-0.576,0.575-0.936,0.863h0.936 h13.536l7.632-9.792l3.096,9.792h14.472l7.2-9.863l2.952,9.863h18.001c-1.873-4.104-2.953-6.624-3.961-9.863l-5.111-15.408 l5.688-7.488h31.68l7.129,22.752c0.936,2.808,1.584,5.112,2.303,10.008h19.008c-2.447-4.607-3.096-6.624-4.031-9.936 L161.811,130.061z M50.785,159.221l15.048-19.944l6.552,19.944H50.785z M98.161,187.013l-3.456-10.944l5.184-7.056l3.816,10.729 L98.161,187.013z M132.792,159.221l14.328-19.944l6.553,19.944H132.792z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "138.337,118.613 224.828,3.989 211.58,3.989 125.089,118.613 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAxa);
export default __webpack_public_path__ + "static/media/axa.16f9699fd2202c602da7b1bdc52281e1.svg";
export { ForwardRef as ReactComponent };